import { useQuery } from 'react-query';
import QueryKeys from '../queryKeys';
import { getUngroupedCasesCaseGroup } from '../../caseGroups';
import { OrganizationQueryParams } from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';

const useUngroupedCasesCaseGroup = ({
  params,
  options,
}: IQueryRequest<OrganizationQueryParams>) => {
  const { organizationId } = params;

  return useQuery({
    ...options,
    queryKey: [QueryKeys.getUngroupedCasesCaseGroup, organizationId],
    queryFn: async () => {
      const { data } = await getUngroupedCasesCaseGroup(organizationId);

      return data.data;
    },
  });
};

export default useUngroupedCasesCaseGroup;
